// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/announcement/annoucement.scss
// module id = 129
// module chunks = 0